import React, { useState } from 'react';
import * as locCon from '../LocalConstants';
import CustomText from '../elements/CustomText';
import { RefContextLanguage } from '../providers/LanguageProvider';
import * as libCon from '../community-hats-js-library/Constants';
import CollectionStatus from '../elements/CollectionStatus';
import { SimpleCopyField, SimpleCopyFieldFromATO } from '../elements/SimpleStoreCopyField';
import { RefLocationTrackerUpToDate, RefPhoneStatus, refreshPhone } from '../hooks/BundleDeviceHooks';
import { showErrorDialogByCode } from '../utils/dialogFunctions';
import { showNotification } from '../utils/generalFunctions';
import CustomSpin from '../elements/CustomSpin';
import { CustomPrimaryButtonWithDisability } from '../elements/CustomButton';
import { RefATOField } from '../hooks/StoreHooks';
import { goToThirdPartyLink, isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions';
import { formatDistanceShort, formatToStudyLocationReadable } from '../community-hats-js-library/utils/dateFunctions';
import { ExportOutlined } from '@ant-design/icons';

function PhoneStatusViewer({ includeTitle = true }) {
  const i18n = RefContextLanguage();

  const [status, message] = RefPhoneStatus();
  const locationTrackerUpToDate = RefLocationTrackerUpToDate();

  const serial = RefATOField(locCon.AT_OBJECT_PHONE, libCon.ATF_SERIAL);
  const lastUploaded = RefATOField(locCon.AT_OBJECT_PHONE, libCon.ATF_LAST_UPLOADED);

  const [isSynching, setisSynching] = useState(false);

  const refreshRecords = async () => {
    setisSynching(true);
    let response = await refreshPhone();

    if (response !== libCon.OK) showErrorDialogByCode(response);
    else showNotification(i18n.t('refreshComplete'));

    setisSynching(false);
  };

  return (
    <div className="verticalSection">
      {includeTitle ? (
        <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t('locationTrackerApp')}</CustomText>
      ) : (
        <div></div>
      )}

      <CollectionStatus status={status} message={message} />

      {locationTrackerUpToDate === false ? (
        <div className="horizontalSection" style={{ alignItems: 'center', justifyContent: 'center' }}>
          <CustomText type={locCon.INFO_TEXT}>{i18n.t('goToLocationTrackerApp')}</CustomText>
          <ExportOutlined
            style={{ marginLeft: 15, color: 'var(--primary-color-5)', fontSize: 30 }}
            onClick={() => {
              goToThirdPartyLink(libCon.WIKI_LOCATION_TRACKER_APP);
            }}
          />
        </div>
      ) : (
        <></>
      )}

      <SimpleCopyFieldFromATO title={i18n.t('serial')} atoId={locCon.AT_OBJECT_PHONE} fieldId={libCon.ATF_SERIAL} />

      <SimpleCopyField
        title={i18n.t('lastUploaded')}
        value={
          isNullOrUndefined(lastUploaded) ? (
            i18n.t('never')
          ) : (
            <>
              {`${formatToStudyLocationReadable(lastUploaded, true, false)}`}
              <br />
              {`(${formatDistanceShort(lastUploaded)})`}
            </>
          )
        }
        enableCopy={false}
      />

      {isSynching ? (
        <CustomSpin type={locCon.BUTTON_SPINNER} />
      ) : (
        <CustomPrimaryButtonWithDisability
          isDisabled={isNullOrUndefined(serial)}
          title={i18n.t('incompleteDeployment')}
          description={i18n.t('addSerial')}
          onClick={() => refreshRecords()}
        >
          {i18n.t('refresh')}
        </CustomPrimaryButtonWithDisability>
      )}
    </div>
  );
}

export default PhoneStatusViewer;
